// DS: i1.3
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Points: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
        <path d="M3.627 5.035a5.926 5.926 0 0 0 7.126 7.548 5.19 5.19 0 0 1-7.126-7.548M8.81 1.953a4.815 4.815 0 1 1 .407 9.621 4.815 4.815 0 0 1-.407-9.62"></path>
      </svg>
    </IconWrap>
  );
};
Points.displayName = 'Points';

export default Points;
